import React, { memo, useCallback, useState, Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';
import moment from 'moment';

import { Checkbox, ShowItemsSelectPageCount, Message, Pagination } from '../../utilites';
import { ActionButton, ConfirmModal } from '../../common';
import {
  pageOptions,
  contractStatuses,
  viewDocument,
  creditDealTypeCode,
  WITHDRAWAL_OPERATION,
} from '../../../helpers/data-constants';
import {filtersSelectedDeals, getCodeFromDeals, permissionsAccess, useQuery, validateDelayDays} from '../../../helpers/common';
import {
  getInventories,
  getInventoryDeals,
  changeContractStatuses,
  getOperations,
} from '../../../redux/actions/contractAction';
import { getListUsers } from '../../../redux/actions/userAction';
import WitndrawalInwentoryDetails from './WitndrawalInwentoryDetails/WitndrawalInwentoryDetails';
import Loader from './Loader/Loader';

import './witndrawalInwentory.scss';

import Arrow from '../../../assets/icons/arrow-down.svg';
import { useHistory } from 'react-router-dom';
import { createMessage, createMessageFailed, clearMessagesError } from '../../../redux/actions/kbExchangeActions';
import { clearContractError } from '../../../redux/actions/contractAction';


const initialState = {
  currentPage: 1,
  pageRange: pageOptions[0].value,
  reqId: null,
  reqParamTN: [],
  isToTransfer: false,
  isKBWithdrawal: false,
};

const WitndrawalInwentory = memo(({
                                    dealStatus,
                                    setError,
                                    stateSearch
}) => {
  const {cashBoxIds, fullName, dealNumber, typeDeal, delaysDay, typeDuration} = stateSearch;
  const {
    inventoriesData: { inventories, total },
    isLoading,
    commonError,
    inventory,
    changeContract,
    operations,
  } = useSelector(({ contract }) => contract);
  const { listUsers, isLoading: userLoading, accessFeatures } = useSelector(({ user }) => user);
  const { kb } = useSelector(( kb ) => kb);
  const dispatch = useDispatch();

  const [state, setState] = useState(initialState);
  const [allChecked, setAllChecked] = useState(false);
  const [TN, setTN] = useState([]);
  const [selectedDeals, setSelectedDeals] = useState([]);
  const notEmpty = TN && TN.length !== 0;
  const withdrawal = dealStatus === contractStatuses.WITHDRAWAL.param;
  const emptyInventory = dealStatus === contractStatuses.INVENTORY.param;
  let error = commonError || kb.commonError;

  const history = useHistory()
  const query = useQuery()
  const queryPageRange = query.get('pageRange')
  const queryPage = query.get('page')
  const queryStatus = query.get('dealStatus')

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      currentPage: 1,
    }))
  }, [cashBoxIds, dealNumber, typeDeal, fullName, delaysDay])

  useEffect(() => {
    setAllChecked(false);
    return () => {
      dispatch(clearContractError())
      dispatch(clearMessagesError())
      setState((prev) => ({
        ...prev,
        currentPage: 1,
        pageRange: pageOptions[0].value,
      }));
    };
  }, [dealStatus]);

  useEffect(() => {
    if(queryStatus === dealStatus) {
      let actualPageRange = state.pageRange;
      let actualPage = state.currentPage;

      if (!!queryPageRange) actualPageRange = +queryPageRange;
      if (!!queryPage) actualPage = +queryPage;
      setState((prev) => ({
        ...prev,
        currentPage: actualPage,
        pageRange: actualPageRange,
      }));
    }
  }, []);

  useEffect(() => {
    history.push({
      search: `?dealStatus=${dealStatus}&pageRange=${state.pageRange}&page=${state.currentPage}`
    })
  }, [dealStatus, state.pageRange, state.currentPage])

  useEffect(() => {
    const availableDepartaments = JSON.parse(localStorage.getItem('AVAILABLE_DEPARTMENTS'));
    const transferIds = []
    for (let i = 0; i < dealNumber.length; i++) {
      if (!dealNumber[i].transferId) {
        transferIds.push(dealNumber[i].value)
      } else {
        transferIds.push(dealNumber[i].transferId)
      }
    }
    const validationResult = validateDelayDays(delaysDay);

    if (validationResult) {
      setError(validationResult);
      return;
    } else {
      setError('')
    }

    if (withdrawal) {
      dispatch(
        getInventories(
          state.pageRange,
          transferIds.length ? 1 : state.currentPage,
          contractStatuses.WITHDRAWAL.param,
          true,
          'transferDate',
          contractStatuses.WITHDRAWAL.param,
            permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                ? availableDepartaments.join(',')
                : cashBoxIds.map((i) => i.value).join(','),
          typeDuration.map(i => i.value).join(','),
          fullName.map(i => i.value).join(','),
          transferIds.join(','),
          typeDeal.map(i => i.value).join(','),
          delaysDay.from,
          delaysDay.to,
        ),
      );
    }
    if (emptyInventory) {
      dispatch(
        getInventories(
          state.pageRange,
          transferIds.length ? 1 : state.currentPage,
          contractStatuses.INVENTORY.param,
          true,
          'transferDate',
          contractStatuses.INVENTORY.param,
            permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                ? availableDepartaments.join(',')
                : cashBoxIds.map((i) => i.value).join(','),
          typeDuration.map(i => i.value).join(','),
          fullName.map(i => i.value).join(','),
          transferIds.join(','),
          typeDeal.map(i => i.value).join(','),
          delaysDay.from,
          delaysDay.to,
        ),
      );
    }
  }, [
    state.pageRange,
    state.currentPage,
    dispatch,
    dealStatus,
    changeContract,
    emptyInventory,
    withdrawal,
    cashBoxIds,
    fullName,
    dealNumber,
    typeDeal,
    delaysDay,
    typeDuration
  ]);

  useEffect(() => {
    if (inventories.length !== 0) {
      const listUsers = [...new Set(inventories.map(({ userId }) => userId))].join(',');
      dispatch(getListUsers(listUsers));
    }
  }, [inventories, dispatch]);

  useEffect(() => {
    if (inventories && inventories.length !== 0 && listUsers && listUsers.length !== 0) {
      const formattedTN = inventories.map((i) => {
        i.checked = false;
        i.isVisible = false;
        i.userFullName = listUsers.find((user) => user.id === i.userId)
          ? listUsers.find((user) => user.id === i.userId).fullName
          : null;
        return i;
      });
      setState((prev) => ({
        ...prev,
        reqParamTN: formattedTN.map(({ transferId }) => ({
          transferId,
          size: 1000,
          page: 1,
          isTabLoading: false,
        })),
      }));
      setTN(formattedTN);
    } else {
      setTN([]);
    }
  }, [inventories, listUsers]);

  useEffect(() => {
    if (
      TN &&
      TN.length !== 0 &&
      inventories &&
      inventories.length !== 0 &&
      !_isEqual(inventory, {}) &&
      inventory.deal.length !== 0
    ) {
      const dataInventory = _cloneDeep(TN.find(({ transferId }) => transferId === state.reqId));
      dataInventory.deal = {
        ...inventory,
        deal: inventory.deal.map((i) => {
          i.checked = dataInventory.hasOwnProperty('checked') ? dataInventory.checked : allChecked;
          return i;
        }),
      };

      const ind = TN.findIndex(({ transferId }) => transferId === state.reqId);
      setTN((prev) => [...prev.slice(0, ind), dataInventory, ...prev.slice(ind + 1)]);

      const newReqParam = {
        ...state.reqParamTN.find(({ transferId }) => transferId === state.reqId),
      };
      newReqParam.isTabLoading = false;
      const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === state.reqId);
      setState((prev) => ({
        ...prev,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }
  }, [inventory]);

  useEffect(() => {
    if (notEmpty) {
      const TNChecked = TN.filter((i) => {
        const arrDeal = TN.filter((i) => i?.deal);
        if (arrDeal.length !== 0) {
          if (i.deal?.deal && i.deal.deal.length !== 0) {
            return i.deal.deal.filter((item) => item.checked).length !== 0 || i.checked;
          } else {
            return i.checked;
          }
        } else {
          return i.checked;
        }
      });

      if (TNChecked.length !== 0 && TN.filter((i) => i?.deal).length !== 0) {
        const TNDealChecked = TNChecked.map((i) => {
          if (i?.deal && i.deal.deal.length !== 0) {
            if (i.deal.deal.filter((item) => item.checked).length !== 0) {
              return {
                ...i,
                deal: {
                  ...i.deal,
                  deal: i.deal.deal.filter((item) => item.checked),
                },
              };
            } else {
              return { ...i, deal: null };
            }
          } else {
            return i;
          }
        });
        setSelectedDeals(TNDealChecked);
      } else {
        setSelectedDeals(TNChecked);
      }
    }
  }, [TN, notEmpty]);

  useEffect(() => {
    if (commonError && state.reqParamTN.length !== 0) {
      setState((prev) => ({
        ...prev,
        reqParamTN: prev.reqParamTN.map((i) => ({ ...i, isTabLoading: false })),
      }));
    }
  }, [commonError]);

  const onPageRangeChange = useCallback((value) => {
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
    setAllChecked(false);
  }, []);

  const handlePageChange = useCallback((page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
    setAllChecked(false);
  }, []);

  const handleAllContractCheck = useCallback(() => {
    if (notEmpty) {
      const arrDeal = TN.filter((i) => i?.deal);
      if (arrDeal.length !== 0) {
        setTN((prev) =>
          prev.map((item) => {
            if (item?.deal) {
              return {
                ...item,
                checked: !allChecked,
                deal: {
                  ...item.deal,
                  deal: item.deal.deal.map((i) => ({
                    ...i,
                    checked: !allChecked,
                  })),
                },
              };
            } else {
              return {
                ...item,
                checked: !allChecked,
              };
            }
          }),
        );
      } else {
        setTN((prev) =>
          prev.map((item) => ({
            ...item,
            checked: !allChecked,
          })),
        );
      }

      setAllChecked(!allChecked);
    }
  }, [allChecked, TN, notEmpty]);

  const changeVisible = (id) => {
    let ind = TN.findIndex((item) => item.transferId === id);
    let newArray = _cloneDeep(TN);
    newArray[ind].isVisible = !TN[ind].isVisible;
    setTN(newArray);

    const newReqParam = { ...state.reqParamTN.find(({ transferId }) => transferId === id) };
    const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === id);
    const { page, size } = newReqParam;

    if (newArray[ind].isVisible) {
      newReqParam.isTabLoading = true;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    } else {
      newReqParam.isTabLoading = false;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }

    if (emptyInventory && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.INVENTORY.param, false));
    }

    if (withdrawal && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.WITHDRAWAL.param, false));
    }
  };

  const handleTNCheck = useCallback(
    (e) => {
      if (notEmpty) {

        const id = TN.findIndex((item) => item.transferId + item.transferDate === e.target.id);
        changeVisible(TN[id].transferId)
        
        const newArray = _cloneDeep(TN);
        newArray[id].checked = !TN[id].checked;

        if (newArray[id].deal?.deal) {
          newArray[id].deal.deal = TN[id].deal.deal.map((i) => ({
            ...i,
            checked: !TN[id].checked,
          }));
        }

        setTN(newArray);
      }
    },
    [TN, notEmpty],
  );

  const handleContractCheck = useCallback(
    (e, transferId) => {
      if (notEmpty) {
        let tnId = TN.findIndex((item) => item.transferId === transferId);
        let contractId = TN[tnId].deal.deal.findIndex((i) => i.id === +e.target.id);
        let newArray = _cloneDeep(TN);
        newArray[tnId].deal.deal[contractId].checked = !TN[tnId].deal.deal[contractId].checked;
        setTN(newArray);
      }
    },
    [TN],
  );

  const openModal = useCallback(
    (view) => {
      if (selectedDeals.length) setState((prev) => ({ ...prev, [view]: true }));
    },
    [selectedDeals],
  );

  const openModalTransferToKB = useCallback(  
    (view) => {
      if (selectedDeals.length && selectedDeals[0].deal === null ) { 
        dispatch(createMessageFailed('Не выбран договор для передача данных в АИС КБ')) 
      }
      else if (selectedDeals.length 
                && selectedDeals[0].deal !== null 
                && selectedDeals[0].deal.deal.length === 1) {  
        setState((prev) => ({ ...prev, [view]: true }))
        const dealId = selectedDeals[0].deal.deal[0].id;
        dispatch(getOperations(dealId));
      } else if ( selectedDeals.length 
        && selectedDeals[0].deal !== null 
        && selectedDeals[0].deal.deal.length > 1 ){
        dispatch(createMessageFailed('Передача данных в АИС КБ возможна только для одного договора'))
      }
    },
    [selectedDeals, dispatch],
  );

  const handleCloseModal = useCallback((view) => {
    setState((prev) => ({ ...prev, [view]: false }));
  }, []);

  const addToTransfer = useCallback(() => {
    handleCloseModal(viewDocument.isToTransfer);

    const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      dispatch(
        changeContractStatuses(dealIds, contractStatuses.TOTRANSFER.param, transferIds, dealStatus),
      );

      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      setAllChecked(false);
    } else {
      dispatch(
        changeContractStatuses(dealIds, contractStatuses.TOTRANSFER.param, transferIds, dealStatus),
      );

      setAllChecked(false);
    }
  }, [handleCloseModal, dispatch, state.currentPage, TN.length, selectedDeals, dealStatus]);

  const sendWithdrawalKB = useCallback(() => {
    handleCloseModal(viewDocument.isKBWithdrawal);
    const dealId = selectedDeals[0].deal.deal[0].id;

    const code = getCodeFromDeals(selectedDeals[0].deal.deal)
    const operation = operations.find(operation => operation.type === WITHDRAWAL_OPERATION)
    dispatch(createMessage({ dealId: dealId, type: 'WITHDRAWAL', operationId: operation.id, codes: [creditDealTypeCode.MFO_LOAN_AGREEMENT, code] }));
  }, [handleCloseModal, dispatch, selectedDeals, operations]);

  const closeConfirm = useCallback(
    () => handleCloseModal(viewDocument.isToTransfer),
    [handleCloseModal],
  );

  const closeKBConfirm = useCallback(
    () => handleCloseModal(viewDocument.isKBWithdrawal),
    [handleCloseModal],
  );

  return (
    <>
    { ( error && < Message type="error" text={error} /> ) }  
      <div className="content-datatable">
        <div className="content-datatable-header sticky">
          <div className="content-datatable-header-left">
            <div className="action-items">
              {
                  permissionsAccess("action.deal.status.transfer.totransfer") &&
                  <ActionButton
                      text={accessFeatures['cars.feature']
                          ? "Вернуть на передачу / в гараж"
                          : "Вернуть на передачу"}
                      func={openModal}
                      param={viewDocument.isToTransfer}
                  />
              }
              {withdrawal && permissionsAccess("action.overdue.load.aiskb") && (
                  <ActionButton
                      text="Передача данных в АИС КБ"
                  func={openModalTransferToKB}
                  param={viewDocument.isKBWithdrawal}
                />
              )}
            </div>
          </div>
          <div className="content-datatable-header-right">
            <ShowItemsSelectPageCount
              options={pageOptions}
              change={onPageRangeChange}
              wrapClass={'padding-select'}
              statePageRange={state.pageRange}
            />
          </div>
        </div>
        <div className="content-datatable-content">
          {isLoading || userLoading ? (
            <Loader pageRange={state.pageRange} />
          ) : (
            <table className='table hover'>
              <thead>
                <tr className="witndrawalInwentory-table-header">
                  <th scope="col">
                    <Checkbox
                      label="Номер"
                      id="checkboxContractSelectAll"
                      name="checkboxContractSelectAll"
                      onChange={handleAllContractCheck}
                      value={allChecked}
                    />
                  </th>
                  <th scope="col">
                    <p>
                      Тип <br />
                      документа
                    </p>
                  </th>
                  <th scope="col">
                    <p>Отправитель</p>
                  </th>
                  <th scope="col">
                    <p>Дата</p>
                  </th>
                  <th scope="col">
                    <p>Пользователь</p>
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {notEmpty &&
                  TN.map((tn, ind) => {
                    return (
                      <Fragment key={tn.transferId}>
                        <tr>
                          <td>
                            <div className="table-cellcontent">
                              <Checkbox
                                id={tn.transferId + tn.transferDate}
                                name={tn.transferId}
                                onChange={handleTNCheck}
                                value={tn.checked}
                              />
                              <p>{tn.documentNumber}</p>
                            </div>
                          </td>
                          <td>
                            <p>Опись</p>
                          </td>
                          <td>
                            <p>{tn.sendCashboxName}</p>
                          </td>
                          <td>
                            <p>{moment(tn.transferDate).format('DD.MM.YYYY')}</p>
                          </td>
                          <td>
                            <p>{tn.userFullName}</p>
                          </td>
                          <td
                            className={`witndrawalInwentory-table-col-arrow${
                              tn.isVisible ? '-up' : ''
                            }`}>
                            <Arrow onClick={() => changeVisible(tn.transferId)} />
                          </td>
                        </tr>
                        <tr
                          className={`witndrawalInwentory-table-line${
                            tn.isVisible ? '-visible' : ''
                          }`}>
                          <td colSpan="7">
                            <WitndrawalInwentoryDetails
                              key={tn.transferId}
                              tn={tn}
                              transferId={tn.transferId}
                              isTabLoading={state.reqParamTN[ind].isTabLoading}
                              handleContractCheck={handleContractCheck}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <Pagination
        total={Math.ceil(total / state.pageRange)}
        current={state.currentPage}
        handlePageChange={handlePageChange}
      />
      <ConfirmModal
        isOpen={state.isToTransfer}
        handleClose={closeConfirm}
        handleAction={addToTransfer}
        headerText="Вы хотите переместить на передачу / в гараж?"
      />
      <ConfirmModal
        isOpen={state.isKBWithdrawal}
        handleClose={closeKBConfirm}
        handleAction={sendWithdrawalKB}
        headerText="Вы хотите отправить изъятие в КБ?"
      />
    </>
  );
});

export default WitndrawalInwentory;
